<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid align-items-center mb-3">
    <div class="col-1">
      <button pButton type="button" class="btn-primary-full w-full"
              label="{{ 'BTN_AGREGAR' | translate }}" icon="fa fa-plus"
              (click)="agregar()" [disabled]="mostrarFormulario"></button>
    </div>
    <div class="col-5  col-offset-6" *ngIf="!mostrarFormulario">
      <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}"
             class="w-full input-search-premium" [(ngModel)]="search"
             (input)="dt.filter($any($event.target).value, 'flujoVentaPaso', 'contains')">
    </div>
  </div>

  <div class="form-transition-container" [class.visible]="mostrarFormulario && !detalle">
    <div class="container-premium-form p-4 mb-4">
      <h3 class="text-secondary font-bold">{{ 'PRODUCTOFLUJOVENTA.LBL_AGREGARCONFIGURACION' | translate }}</h3>
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioFrecuencia" name="nomFormularioFrecuencia">
        <div class="grid form-group align-items-center">
          <!-- Nombre del paso -->
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>* {{ 'PRODUCTOFLUJOVENTA.LBL_NOMBREPASO' | translate }}</label>
              <p-multiSelect *ngIf="!editando" id="idFlujoVentaPaso" name="nomFlujoVentaPaso" [options]="lisFlujoPaso" filter="filter"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                             formControlName="idFlujoVentaPaso" appendTo="body"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <label *ngIf="editando" class="falso-combo-texto"><b>{{ nombrePasoEditando }}</b></label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFlujoVentaPaso.invalid">
                {{ 'PRODUCTOFLUJOVENTA.LBL_NOMBREPASO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <!-- Naturaleza -->
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>* {{ 'PRODUCTOFLUJOVENTA.LBL_NATURALEZA' | translate }}</label>
              <p-multiSelect id="idTipoPersona" name="nomTipoPersona" [options]="listaTiposPersonas"
                             filter="filter" appendTo="body"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="naturaleza"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.naturaleza.invalid">
                {{ 'PRODUCTOFLUJOVENTA.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <!-- Checkboxes -->
          <div class="col-12 md:col-6 lg:col-6 pt-3">
            <div class="grid">
              <div class="col-4">
                <p-checkbox label="{{ 'PRODUCTOFLUJOVENTA.LBL_INDICADORSOLICITUDTRADICIONAL' | translate}}" binary="true"
                            id="idIndicadorSolicitudTradicional"
                            formControlName="indicadorSolicitudTradicional"></p-checkbox>
              </div>
              <div class="col-4">
                <p-checkbox label="{{ 'PRODUCTOFLUJOVENTA.LBL_INDICADORDIGITAL' | translate}}" binary="true"
                            id="idIndicadorDigital"
                            formControlName="indicadorDigital"></p-checkbox>
              </div>
              <div class="col-4">
                <p-checkbox label="{{ 'PRODUCTOFLUJOVENTA.LBL_INDICADORPREAPROBADO' | translate}}" binary="true"
                            id="idIndicadorPreaprobado"
                            formControlName="indicadorPreaprobado"></p-checkbox>
              </div>
            </div>
          </div>

          <!-- Tipo Preaprobado -->
          <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorPreaprobado.value">
            <div class="div-form">
              <label>* {{ 'PRODUCTOFLUJOVENTA.LBL_TIPOPREAPROBADO' | translate }}</label>
              <p-multiSelect id="tiposPreaprobados" name="tiposPreaprobados" [options]="lisTiposPreaprobados"
                             filter="filter" appendTo="body"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="tiposPreaprobados"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tiposPreaprobados.invalid">
                {{ 'PRODUCTOFLUJOVENTA.LBL_TIPOPREAPROBADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 text-center py-3">
            <div *ngIf="!guardando" class="flex justify-content-center gap-3">
              <button type="button" class="btn-primary-outline" pButton label="{{ 'BTN_CANCELAR' | translate }}" (click)="cancelarEdit()"></button>
              <button class="btn-primary-full" icon="fa fa-check-circle" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="grid">
    <div class="col-5 col-offset-7" *ngIf="mostrarFormulario">
      <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}"
             class="w-full input-search-premium" [(ngModel)]="search"
             (input)="dt.filter($any($event.target).value, 'flujoVentaPaso', 'contains')">
    </div>
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="guardando" #dt
               [value]="lisProductosFrecuenciasListado"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom" styleClass="table-premium" >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.flujoVentaPaso}}</td>
            <td>{{row.tipoPersona}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorSolicitudTradicional" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorDigital" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorPreaprobado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">{{row.tiposPreaprobadosLabel}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="btn-action-premium mr-1" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)" *ngIf="!detalle"></button>
                <button type="button" class="btn-action-premium" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton
                        (click)="inhabilitar(row)" *ngIf="!detalle"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="frecuencias" appendTo="body">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
